import { IWebsite } from "../models/Website";

export const WIDGET_HOST = "https://widget.recyclingsoftware.co.uk";

/**
 * The script tag a customer pastes into their site to load the widget for a given website.
 * Display settings that affect the host page (iframe height, z-index) are baked in so the
 * embed matches what they configured in the dashboard.
 */
export function getEmbedCode(token: string, customerId: string, website: IWebsite) {
  const googleTag = website.googleTag ?? null;
  const iframeHeight = website.displaySetting?.iframeHeight ?? null;
  const zIndex = website.displaySetting?.zIndex ?? null;

  let embedCode = `<div id="my-widget-container">
      <script>
        (function(w, d, s, customerId, token, websiteId, googleTag, iframeHeight, zIndex) {
          const params = new URLSearchParams(w.location.search);

          const initOptions = { customerId, token, websiteId };
          if (googleTag) {
            initOptions.googleTag = googleTag;
          }
          if (iframeHeight) {
            initOptions.height = iframeHeight;
          }
          if (zIndex !== null && zIndex !== undefined) {
            initOptions.zIndex = zIndex;
          }

          for (const [key, value] of params.entries()) {
            if (key === 'customerId' || key === 't' || key === 'websiteId') continue;
            initOptions[key] = value;
          }

          var js = d.createElement(s), fjs = d.getElementsByTagName(s)[0];
          js.src = "${WIDGET_HOST}/widget/widget.js";
          js.onload = function() {
            if (w.MyWidget) {
              w.MyWidget.init(initOptions);
            }
          };
          fjs.parentNode.insertBefore(js, fjs);

        })(window, document, 'script', 'CUSTOMER_ID', 'CUSTOMER_TOKEN', 'WEBSITE_ID', GOOGLE_TAG, IFRAME_HEIGHT, Z_INDEX);
      </script>
    </div>
  `;

  embedCode = embedCode.replace("CUSTOMER_ID", customerId);
  embedCode = embedCode.replace("CUSTOMER_TOKEN", token);
  embedCode = embedCode.replace("WEBSITE_ID", website.id);
  embedCode = embedCode.replace("GOOGLE_TAG", JSON.stringify(googleTag));
  embedCode = embedCode.replace("IFRAME_HEIGHT", iframeHeight?.toString() || "null");
  embedCode = embedCode.replace("Z_INDEX", zIndex?.toString() || "null");

  // minify
  embedCode = embedCode.replace(/[\n\t]/g, "");

  return embedCode;
}

/** Standalone URL for the widget, for linking to it directly rather than embedding. */
export function getWidgetUrl(token: string, customerId: string, website: IWebsite) {
  const url = new URL(`${WIDGET_HOST}/`);
  url.searchParams.set("customerId", customerId);
  url.searchParams.set("t", token);
  url.searchParams.set("websiteId", website.id);
  if (website.googleTag) {
    url.searchParams.set("googleTag", website.googleTag);
  }

  return url.toString();
}
